export default "__VITE_ASSET__BdlGu_ID__"